import { render } from "./container-bulk-import.vue?vue&type=template&id=947165ba&scoped=true"
import script from "./container-bulk-import.vue?vue&type=script&lang=js"
export * from "./container-bulk-import.vue?vue&type=script&lang=js"

import "./container-bulk-import.vue?vue&type=style&index=0&id=947165ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947165ba"]])

export default __exports__